import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import { Link, Redirect } from 'react-router-dom'
import {
    FormattedMessage,
    FormattedNumber,
    injectIntl,
    defineMessages, FormattedDate,
} from 'react-intl'
import ImportSaleModal from "./importsalemodal.component.jsx"
import StandardList from '../../common/listing/list.component.jsx'
import SideBar from '../../common/layout/sidebar.component.jsx'
import LoadingSpinner from '../../common/spinner/loading.component.jsx'
import Pagination from '../../common/listing/pagination.component.jsx'
import DebounceInput from "react-debounce-input";
import Icon from "../../common/icon/icon.component.jsx";
import NoResult from "../../common/listing/noresult.component.jsx";
import InvoicesTabs from "../../common/layout/tabs/invoices.component.jsx";
import SortLink from "../../common/listing/sortlink.component.jsx";

const messages = defineMessages({
    "search_placeholder": {
        id: 'invoice.listing.search_placeholder',
        defaultMessage: 'Search an invoice...',
    },
    "customer_type_placeholder": {
        id: 'invoice.listing.customer_type_placeholder',
        defaultMessage: 'Customer type',
    },
    "status_filter_placeholder": {
        id: 'invoice.listing.status_filter_placeholder',
        defaultMessage: 'Filter by status',
    },
    "identifier": {
        id: "invoice.listing.headers.id_label",
        defaultMessage: 'ID'
    },
})


class LightspeedSalesListing extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            headers: [],
            rows: [],
            footer: [],
            modal: '',
            activePage: 1,
            pageSize: 10,
            totalItemsCount: 0,
            loading: true,
            searchKeywords:"",
            sortField: 'identifier',
            asc: false,
            prefLoaded: false,
            sales: [],
        }

        this.openInvoiceCreationModal = this.openInvoiceCreationModal.bind(this)
        this.closeInvoiceCreationModal = this.closeInvoiceCreationModal.bind(this)
        this.handleSortLinkChange = this.handleSortLinkChange.bind(this)
        this.onLoading = this.onLoading.bind(this)
        this.refreshListing=this.refreshListing.bind(this)
        this.updateListing=this.updateListing.bind(this)
        this.handleChangeSearch=this.handleChangeSearch.bind(this)
        this.isImportable=this.isImportable.bind(this)
        this.isAccountPayment=this.isAccountPayment.bind(this)
    }

    componentDidMount() {
        this.updateListing()
        SideBar.activateMenu('invoice')

    }


    handleSortLinkChange(sortField, asc) {
        let sales=this.state.sales
        let orderedSales=[]
        let ascOrder=asc?1:-1
        let ascOrderSecondValue=(ascOrder==1?-1:1)
        
        if( sortField=="amount"){
            orderedSales=sales.sort((a,b) => {
                let firstElement=parseFloat(a[sortField])
                let secondElement=parseFloat(b[sortField])
                return (firstElement>secondElement ? ascOrder : (secondElement > firstElement) ? ascOrderSecondValue: 0)
            })
        }
        else if (sortField=="customer.lastName"){
            orderedSales=sales.sort((a,b) => {
                let firstElement=a.customer.lastName
                let secondElement=b.customer.lastName
                return (firstElement>secondElement ? ascOrder : (secondElement > firstElement) ? ascOrderSecondValue: 0)
            })    
        }
        else{
            orderedSales=sales.sort((a,b) => {
                let firstElement=a[sortField]
                let secondElement=b[sortField]
                return (firstElement>secondElement ? ascOrder : (secondElement > firstElement) ? ascOrderSecondValue: 0)
            })
        }

        this.setState({
            sales: orderedSales,
            sortField: sortField,
            asc: asc,
        }, () => {
            this.refreshListing(orderedSales)
        })
    }

    isImportable(sale){
        if (sale.amount<=0){
            return false
        }
        if(sale.salePayments && (!Array.isArray(sale.salePayments) && sale.salePayments.PaymentType.code!="SCA")){
            return false
        }

        if(sale.salePayments && Array.isArray(sale.salePayments)){
            var creditAccountPayment=sale.salePayments.filter(pay=>pay.PaymentType.code=="SCA")
            if(sale.salePayments.length==creditAccountPayment.length){
                return false
            }
        }

        if(sale.hasQmNotes){
            return false
        }

        return true
    }

   
    handleChangeSearch(event){
        var valueSearch = event.target.value
        if (valueSearch) {
            this.setState({searchKeywords: valueSearch}, ()=>this.updateListing())
        } else {
            this.setState({ searchKeywords: ""}, ()=>this.updateListing())
        }
    }

    onLoading(aux) {
        this.setState({ loading: aux })
    }

    refreshListing(sales){
        this.setState({
            headers: sales.length > 0 ? this.headers() : [],
            rows: sales.map(q => this.row(q)),
            footer: this.footer(sales),
            loading: false,
        })
    }

    updateListing() {
        this.setState({
            loading: true,
        })
        let data={
            limit:"10",
            keywordSaleId:this.state.searchKeywords,
        }

        AppContext.getApiClient().post('/ls-retail/invoices/importable',data).then(res => {
        
            const r = res
            this.setState({
                sales: r.data,
                headers: r.data.length > 0 ? this.headers() : [],
                rows: r.data.map(q => this.row(q)),
                footer: this.footer(r.data),
                loading: false,
            })
        })

    }

    headers() {
        let headers = [
            <SortLink
                field={'saleId'}
                sortField={this.state.sortField}
                asc={this.state.asc}
                onChange={this.handleSortLinkChange}
            >
                <FormattedMessage
                    id="invoice.lightspeed_listing.header_id"
                    defaultMessage="ID"
                />
            </SortLink>,
        ]
        let classNames = ['']

        headers = headers.concat([
            <SortLink
                field={'customer.lastName'}
                sortField={this.state.sortField}
                asc={this.state.asc}
                onChange={this.handleSortLinkChange}
            >
                <FormattedMessage
                    id="invoice.listing.headers.contact_label"
                    defaultMessage="Contact"
                />
            </SortLink>,
            <SortLink
                field={'ticketNumber'}
                sortField={this.state.sortField}
                asc={this.state.asc}
                onChange={this.handleSortLinkChange}
            >
                <FormattedMessage
                    id="invoice.listing.headers.type_label"
                    defaultMessage="Ticket Number"
                />
            </SortLink>,
            <SortLink
                field={'createTime'}
                sortField={this.state.sortField}
                asc={this.state.asc}
                onChange={this.handleSortLinkChange}
            >
                <FormattedMessage
                    id="invoice.lightspeed_listing.header_date"
                    defaultMessage="Creation Date"
                />
            </SortLink>,
            <SortLink
                field={'amount'}
                sortField={this.state.sortField}
                asc={this.state.asc}
                onChange={this.handleSortLinkChange}
            >
                <FormattedMessage
                    id="invoice.listing.headers.amount_label"
                    defaultMessage="Amount"
                />
            </SortLink>,
            <FormattedMessage
                id="invoice.listing.headers.import_label"
                defaultMessage="Import"
            />

        ])

        classNames = classNames.concat(['', '', '', 'text-center', '',''])

        return {
            classNames: classNames,
            data: headers,
        }
    }

    row(sale) {
        let rows = []
        let classNames = ['']

        const contact =  sale.customerFirstName || sale.customerLastName? sale.customerLastName+" "+sale.customerFirstName:""
        
        rows = rows.concat([
            sale.saleId,
            contact?
                sale.contactId? 
                <Link to={'/contacts/' + sale.contactId+ '/details'}>
                    {contact}
                </Link>:contact
            :
            "-",
            sale.ticketNumber,
            sale.createTime ?
                <FormattedDate
                    year='numeric'
                    month='long'
                    day='numeric'
                    value={new Date(sale.createTime)}
                /> : '-',
            <FormattedNumber
                style="currency"
                currency={AppContext.getAccount().attributes.currency}
                value={sale.amount}
            />,
            sale.invoiceId?
            <div className="text-center mb-2 mt-2">
                <Link to={'/invoices/' + sale.invoiceId+ '/edit'}>
                    {sale.invoiceIdentifier}
                </Link>
            </div>:
            sale.isImportable?
            <div className="text-center mb-2 mt-2">
                <button className="btn btn-outline-primary btn-sm" data-toggle="modal" data-target="#filtersMenus" onClick={()=>this.openInvoiceCreationModal(sale)}>
                    <FormattedMessage
                        id="invoice.listing.headers.import_label"
                        defaultMessage="Import"
                    />
                </button>
             </div>:""
        ])

        classNames = classNames.concat(['', '', '', 'text-center', 'text-right','text-center'])
        return {
            classNames: classNames,
            rowId: sale.id,
            data: rows,
        }
    }

    footer(sales) {
        const saleReducer = (accumulator, currentValue) => accumulator + parseFloat(currentValue.amount);
        let totalAmount = sales.reduce(saleReducer, 0)
        let rows = [
            <strong>
                <FormattedMessage
                    id="invoice.listing.headers.totals_label"
                    defaultMessage="Totals"
                />
            </strong>,
        ]
        let classNames = ['pl-4']

        rows = rows.concat([
            '',
            '',
            <strong>{sales.length}</strong>,
            <FormattedNumber
                style="currency"
                currency={AppContext.getAccount().attributes.currency}
                value={totalAmount}
            />,
            '',
        ])
        classNames = classNames.concat(['', 'pl-4', 'text-center', 'text-center',''])
        return {
            classNames: classNames,
            data: rows,
        }
    }

    isAccountPayment(sale){
        if (sale.salePayments && (!Array.isArray(sale.salePayments) && sale.salePayments.PaymentType.code=="SCA")){
            return true
        }
        return false
    }

    openInvoiceCreationModal(sale) {
        const contact =  sale.customerFirstName || sale.customerLastName? sale.customerLastName+" "+sale.customerFirstName:""
        
        this.setState({
            modal: <ImportSaleModal
                saleId={sale.saleId}
                applyPayments={sale.applyPayments}
                customerId={sale.customerId}
                contactId={sale.contactId? sale.contactId:""}
                contactName={contact}
                onClose={this.closeInvoiceCreationModal}
            />
        })
    }

    closeInvoiceCreationModal(invoiceId) {
        this.setState({
            modal: invoiceId ? <Redirect to={'/invoices/' + invoiceId + '/edit'} /> : ''
        })
    }


    render() {
        if (AppContext.getAccount().attributes.onBoardingStatus === "pending") {
            return <Redirect to={{ pathname: '/' }} />
        }

        let list = <StandardList
            smallLine={true}
            className="row pt-3"
            headers={this.state.headers}
            rows={this.state.rows}
            footer={this.state.footer}
            footerClassName={'bg-secondary text-white'}
            pageSize={this.state.pageSize}
            totalItemsCount={this.state.sales.length}
            selectable={false}
        />
        if (this.state.loading) {
            list = <LoadingSpinner />
        } else if (this.state.rows.length === 0) {
            list = <NoResult noButton={true} />
        }

        return (
            <div>
                <InvoicesTabs />
                {this.state.modal}
                <div className="row ui-has-modules py-1">
                    <div className="col-12 ui-module mb-0 pb-1">
                        <div className="row mb-0">
                            <div className="col-12 col-md-12">
                                <div className="w-100 d-flex">
                                    <div className="row mb-2 mt-2 ml-2 flex-row w-100">
                                        <div className="mb-3 col-md-10 pl-0">
                                            <div className="mb-2 input-group">
                                                <DebounceInput
                                                    onKeyPress={this.props.onKeyPress}
                                                    minLength={0}
                                                    debounceTimeout={500}
                                                    autoComplete={this.props.autoComplete}
                                                    name={this.props.name}
                                                    onChange={this.handleChangeSearch}
                                                    id={this.props.id}
                                                    value={this.state.searchKeywords}
                                                    type="search"
                                                    className="form-control"
                                                    placeholder={this.props.placeholder}
                                                />

                                            </div>
                                        </div>
 
                                        <div className="col-md-2">
                                            <button className="btn btn-outline-primary w-100 mb-2" data-toggle="modal" data-target="#filtersMenus" onClick={this.updateListing}>
                                                <Icon value={"redo"} />
                                                <FormattedMessage
                                                    id="listing.product.import.refresh_btn"
                                                    defaultMessage="Refresh"
                                                />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {list}
                <Pagination
                    showPageSize={true}
                    onPageSizeChange={this.handlePageSizeChange}
                    activePage={this.state.activePage}
                    pageSize={this.state.pageSize}
                    totalItemsCount={this.state.totalItemsCount}
                    onChange={this.handlePageChange}
                >
                </Pagination>
            </div>
        );
    }
}

export default injectIntl(LightspeedSalesListing)



// WEBPACK FOOTER //
// ./src/invoice/lightspeed/lightspeedsaleslisting.component.jsx